import React from 'react';
import ModalForm from '../components/Modal/ModalForm';
import InputsSection from '../components/Modal/InputsSection';
import InputBoxSkeleton from './InputBoxSkeleton';
import ModalButtonsSkeleton from './ModalButtonsSkeleton';

const AssociatedClinicSkeleton = () => {
  return (
    <ModalForm style={{ marginBottom: '2.5rem' }}>
      <InputsSection>
        <InputBoxSkeleton />
        <InputBoxSkeleton />
        <InputBoxSkeleton />
      </InputsSection>
      <InputsSection style={{height:'20rem'}}>
        <InputBoxSkeleton />
      </InputsSection>
      <InputsSection style={{height:'20rem'}}>
      <InputBoxSkeleton style={{width:'75rem',height:'10rem'}}/>
      </InputsSection>
      <ModalButtonsSkeleton />
    </ModalForm>
  );
};

export default AssociatedClinicSkeleton;
